import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { __, sprintf } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import DownloadableBlockIcon from '../downloadable-block-icon';
export default function CompactList(_ref) {
  var items = _ref.items;

  if (!items.length) {
    return null;
  }

  return createElement("ul", {
    className: "block-directory-compact-list"
  }, items.map(function (_ref2) {
    var icon = _ref2.icon,
        id = _ref2.id,
        title = _ref2.title,
        author = _ref2.author;
    return createElement("li", {
      key: id,
      className: "block-directory-compact-list__item"
    }, createElement(DownloadableBlockIcon, {
      icon: icon,
      title: title
    }), createElement("div", {
      className: "block-directory-compact-list__item-details"
    }, createElement("div", {
      className: "block-directory-compact-list__item-title"
    }, title), createElement("div", {
      className: "block-directory-compact-list__item-author"
    }, sprintf(
    /* translators: %s: Name of the block author. */
    __('By %s'), author))));
  }));
}
//# sourceMappingURL=index.js.map